// Use the 'require' syntax which works better with jquery

// See:
// https://jqueryui.com/upgrade-guide/1.12/#official-package-on-npm
// https://github.com/jzaefferer/webpack-jquery-ui/blob/master/index.js

const $ = require("jquery");
window.$ = window.jQuery = $;

require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/menu.css');
require('jquery-ui/themes/base/datepicker.css');
require('jquery-ui/themes/base/theme.css');
require('../scss/themes/base/jquery-ui.css');

require("jquery-ui/ui/widgets/datepicker");
